import React from "react";
export function IconCart() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.423173"
        y="0.423173"
        width="47.1537"
        height="47.1537"
        rx="23.5768"
        fill="white"
      />
      <path
        d="M31.9348 16.6863L24.7323 11.4302C23.6024 10.6065 22.0132 10.847 21.1894 11.977L17.7412 16.6863H31.9348Z"
        fill="#61CC64"
      />
      <path
        d="M36.1072 16.7158H32.484C33.8035 16.7158 34.8168 17.8749 34.6492 19.1798L33.0162 30.0711C32.8777 31.1573 31.9446 31.9665 30.8511 31.9665H34.4742C35.5677 31.9665 36.5008 31.1573 36.6393 30.0711L38.2723 19.1798C38.4473 17.8749 37.4267 16.7158 36.1072 16.7158Z"
        fill="#DCF4FF"
      />
      <path
        d="M33.9715 32.7101H16.9858C15.783 32.7101 14.7988 31.7332 14.7988 30.5304L14.8134 18.8955C14.8134 17.6927 15.7903 16.7158 17.0004 16.7158H35.5972C36.9167 16.7158 37.93 17.8749 37.7623 19.1798L36.1294 30.8147C35.9909 31.9009 35.065 32.7101 33.9715 32.7101Z"
        stroke="#001C43"
        strokeWidth="1.41058"
        strokeMiterlimit="10"
      />
      <path
        d="M14.7988 27.6221H36.297"
        stroke="#001C43"
        strokeWidth="1.41058"
        strokeMiterlimit="10"
      />
      <path
        d="M22.9097 33.4404C22.9097 34.9057 21.7214 36.0867 20.2561 36.0867C18.7908 36.0867 17.6025 34.8984 17.6025 33.4404"
        stroke="#001C43"
        strokeWidth="1.41058"
        strokeMiterlimit="10"
      />
      <path
        d="M32.7856 33.4404C32.7856 34.9057 31.5974 36.0867 30.1321 36.0867C28.6668 36.0867 27.4785 34.8984 27.4785 33.4404"
        stroke="#001C43"
        strokeWidth="1.41058"
        strokeMiterlimit="10"
      />
      <path
        d="M10.8101 14.1719C12.6763 14.7915 14.0833 15.9215 14.8123 17.8096"
        stroke="#001C43"
        strokeWidth="1.69269"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <rect
        x="0.423173"
        y="0.423173"
        width="47.1537"
        height="47.1537"
        rx="23.5768"
        stroke="#E2F6FF"
        strokeWidth="0.846346"
      />
    </svg>
  );
}

export function IconHome() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.417949"
        y="0.417949"
        width="47.1641"
        height="47.1641"
        rx="23.5821"
        fill="white"
      />
      <path
        d="M33.4742 23.3931H30.5654V35.7551H33.4742V23.3931Z"
        fill="#C6ECFF"
      />
      <path
        d="M13.4811 12.1216L12.7539 15.3939H35.6601L34.5693 12.1216H13.4811Z"
        fill="#C6ECFF"
      />
      <path
        d="M13.6592 22.6738V33.9379C13.6592 35.145 14.6336 36.1194 15.8407 36.1194H32.2023C33.4094 36.1194 34.3838 35.145 34.3838 33.9379V22.6738"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
      />
      <path
        d="M21.8455 32.8532H17.846C17.0461 32.8532 16.3916 32.1988 16.3916 31.3989V27.763C16.3916 26.9631 17.0461 26.3086 17.846 26.3086H21.8455C22.6454 26.3086 23.2998 26.9631 23.2998 27.763V31.3989C23.2998 32.1988 22.6454 32.8532 21.8455 32.8532Z"
        fill="#61CC64"
      />
      <path
        d="M35.8937 19.4298L34.992 13.9468C34.8175 12.8924 33.9085 12.1216 32.8395 12.1216H15.2127C14.1437 12.1216 13.2347 12.8924 13.0602 13.9468L12.1585 19.4298C11.904 20.3533 11.8894 21.3713 13.2711 22.7166C13.8237 23.2475 14.5437 23.582 15.2999 23.582C16.5725 23.582 17.6633 22.8402 18.2086 21.7785C18.7468 22.8475 19.8448 23.582 21.1174 23.582C22.3899 23.582 23.488 22.8475 24.0261 21.7785C24.5642 22.8475 25.6623 23.582 26.9348 23.582C28.2074 23.582 29.3054 22.8475 29.8435 21.7785C30.3817 22.8402 31.4724 23.582 32.7523 23.582C33.5158 23.582 34.2284 23.2475 34.7811 22.7166C36.1555 21.3713 36.1482 20.3533 35.8937 19.4298Z"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
      />
      <rect
        x="0.417949"
        y="0.417949"
        width="47.1641"
        height="47.1641"
        rx="23.5821"
        stroke="#E2F6FF"
        strokeWidth="0.835898"
      />
    </svg>
  );
}

export function IconSearch() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.417949"
        y="0.417949"
        width="47.1641"
        height="47.1641"
        rx="23.5821"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2544 35.5246C22.6485 35.5636 23.0482 35.5835 23.4525 35.5835C30.0979 35.5835 35.485 30.1964 35.485 23.551C35.485 16.9057 30.0979 11.5186 23.4525 11.5186C23.0482 11.5186 22.6485 11.5385 22.2544 11.5775C28.3372 12.1788 33.0887 17.31 33.0887 23.551C33.0887 29.7921 28.3372 34.9233 22.2544 35.5246Z"
        fill="#C6ECFF"
      />
      <path
        d="M23.4607 35.584C30.1061 35.584 35.4932 30.1969 35.4932 23.5515C35.4932 16.9062 30.1061 11.519 23.4607 11.519C16.8154 11.519 11.4282 16.9062 11.4282 23.5515C11.4282 30.1969 16.8154 35.584 23.4607 35.584Z"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
      />
      <path
        d="M23.4557 32.3747C28.3289 32.3747 32.2795 28.4241 32.2795 23.5509C32.2795 18.6776 28.3289 14.7271 23.4557 14.7271C18.5824 14.7271 14.6318 18.6776 14.6318 23.5509C14.6318 28.4241 18.5824 32.3747 23.4557 32.3747Z"
        fill="url(#paint0_linear_2175_158048)"
      />
      <path
        d="M26.6699 20.7426C28.2205 20.7426 29.4775 19.4856 29.4775 17.935C29.4775 16.3844 28.2205 15.1274 26.6699 15.1274C25.1193 15.1274 23.8623 16.3844 23.8623 17.935C23.8623 19.4856 25.1193 20.7426 26.6699 20.7426Z"
        fill="white"
      />
      <path
        d="M30.0361 33.4273L32.6432 36.0343C33.5576 36.9488 35.0336 36.9488 35.9401 36.0343C36.8545 35.1198 36.8545 33.6439 35.9401 32.7374L33.333 30.1304"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
      />
      <rect
        x="0.417949"
        y="0.417949"
        width="47.1641"
        height="47.1641"
        rx="23.5821"
        stroke="#E2F6FF"
        strokeWidth="0.835897"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2175_158048"
          x1="27.8049"
          y1="29.9389"
          x2="16.3366"
          y2="24.1181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6E7F7" />
          <stop offset="1" stopColor="#9EE4A1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function IconList() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.417949"
        y="0.417949"
        width="47.1641"
        height="47.1641"
        rx="23.5821"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M31.9494 14.585H29.0161C30.6368 14.585 31.9494 15.8976 31.9494 17.5183V33.285C31.9494 34.9056 30.6368 36.2183 29.0161 36.2183H31.9494C33.5701 36.2183 34.8828 34.9056 34.8828 33.285V17.5183C34.8828 15.8976 33.5701 14.585 31.9494 14.585Z"
        fill="#DCF4FF"
      />
      <path
        d="M31.952 36.2178H16.552C14.9313 36.2178 13.6187 34.9051 13.6187 33.2845V17.5178C13.6187 15.8971 14.9313 14.5845 16.552 14.5845H31.952C33.5727 14.5845 34.8853 15.8971 34.8853 17.5178V33.2845C34.8853 34.9051 33.5727 36.2178 31.952 36.2178Z"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
      />
      <path
        d="M18.3887 12.0181V17.1514"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30.1172 12.0181V17.1514"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.249 27.0498H31.5824"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.3169 31.4526H31.5836"
        stroke="#001C43"
        strokeWidth="1.39316"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M23.7413 22.1024C24.0126 24.3758 21.0793 26.4878 20.0966 27.1258C19.9059 27.2504 19.6639 27.2504 19.4733 27.1258C18.4906 26.4878 15.5499 24.3758 15.8286 22.1024C15.9533 21.0538 16.8259 20.2104 17.8819 20.1004C18.6299 20.0198 19.3193 20.3058 19.7886 20.7971C20.2579 20.3058 20.9473 20.0271 21.6953 20.1004C22.7439 20.2104 23.6166 21.0464 23.7413 22.1024Z"
        fill="#61CC64"
      />
      <rect
        x="0.417949"
        y="0.417949"
        width="47.1641"
        height="47.1641"
        rx="23.5821"
        stroke="#E2F6FF"
        strokeWidth="0.835898"
      />
    </svg>
  );
}

export function IconCheckedWelcome() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3751 13.1251C20.6251 16.8751 17.7976 20.4061 13.8301 21.1951C11.8951 21.5804 9.88781 21.3455 8.0941 20.5237C6.30039 19.7018 4.81167 18.3351 3.83993 16.618C2.8682 14.9008 2.46297 12.9209 2.68196 10.9601C2.90094 8.99926 3.73298 7.15751 5.05959 5.69707C7.78059 2.70007 12.3751 1.87507 16.1251 3.37507"
        stroke="#0090DA"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 11.625L12.375 15.375L21.375 5.625"
        stroke="#0090DA"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconLoadProgress() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
      <path
        d="M35 16V22H29"
        stroke="#0090DA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 32V26H19"
        stroke="#0090DA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5673 20.6662C14.3831 21.1868 14.6558 21.7582 15.1764 21.9425C15.6971 22.1267 16.2685 21.854 16.4527 21.3334L14.5673 20.6662ZM30.36 17.6398L29.6527 18.3467C29.6601 18.3541 29.6676 18.3614 29.6752 18.3685L30.36 17.6398ZM34.3152 22.7285C34.7177 23.1067 35.3506 23.087 35.7288 22.6845C36.107 22.2821 36.0873 21.6492 35.6848 21.271L34.3152 22.7285ZM13.6848 25.271C13.2823 24.8928 12.6494 24.9125 12.2712 25.315C11.8931 25.7175 11.9127 26.3503 12.3152 26.7285L13.6848 25.271ZM17.64 30.3598L18.3473 29.6528C18.3399 29.6454 18.3324 29.6382 18.3248 29.631L17.64 30.3598ZM33.4327 27.3334C33.617 26.8127 33.3442 26.2413 32.8236 26.057C32.3029 25.8728 31.7315 26.1455 31.5473 26.6662L33.4327 27.3334ZM16.4527 21.3334C17.3691 18.7439 19.5499 16.8055 22.229 16.1994L21.7876 14.2487C18.4387 15.0064 15.7127 17.4293 14.5673 20.6662L16.4527 21.3334ZM22.229 16.1994C24.9081 15.5932 27.7109 16.4039 29.6527 18.3467L31.0673 16.9328C28.64 14.5043 25.1365 13.4909 21.7876 14.2487L22.229 16.1994ZM29.6752 18.3685L34.3152 22.7285L35.6848 21.271L31.0448 16.911L29.6752 18.3685ZM12.3152 26.7285L16.9552 31.0885L18.3248 29.631L13.6848 25.271L12.3152 26.7285ZM16.9327 31.0667C19.36 33.4952 22.8635 34.5086 26.2124 33.7508L25.771 31.8002C23.0919 32.4063 20.2891 31.5956 18.3473 29.6528L16.9327 31.0667ZM26.2124 33.7508C29.5613 32.9931 32.2873 30.5702 33.4327 27.3334L31.5473 26.6662C30.6309 29.2557 28.4502 31.194 25.771 31.8002L26.2124 33.7508Z"
        fill="#0090DA"
      />
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#E0F4FF" />
    </svg>
  );
}

export function IconFeatureTag() {
  return (
    <svg
      width="168"
      height="33"
      viewBox="0 0 168 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2175_156942)">
        <path
          d="M43.1381 17.8808C42.669 18.3499 41.9085 18.3499 41.4394 17.8808C40.9703 17.4117 40.9703 16.6511 41.4394 16.1821C41.9085 15.713 42.669 15.713 43.1381 16.1821C43.6072 16.6511 43.6072 17.4117 43.1381 17.8808Z"
          fill="#0D5DF0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.59 30.1237C40.2714 30.1237 39.9659 29.9972 39.7406 29.7719L29.5483 19.5795C28.141 18.1722 28.141 15.8906 29.5483 14.4833L39.7406 4.29094C39.9659 4.06568 40.2714 3.93913 40.59 3.93913L154.473 3.9388C155.136 3.9388 155.674 4.47659 155.674 5.13998L155.674 28.9222C155.674 29.5856 155.136 30.1234 154.473 30.1234L40.59 30.1237ZM39.7406 19.5795C41.1479 20.9868 43.4296 20.9868 44.8368 19.5795C46.2441 18.1722 46.2441 15.8906 44.8368 14.4833C43.4296 13.076 41.1479 13.0761 39.7406 14.4833C38.3334 15.8906 38.3334 18.1722 39.7406 19.5795Z"
          fill="#0D5DF0"
        />
        <path
          d="M54.3551 14.495V13.2273H60.3281V14.495H58.1016V20.5H56.5817V14.495H54.3551ZM62.8494 13.2273V20.5H61.3118V13.2273H62.8494ZM61.5426 12.5241L62.2955 10.9084H63.6946L62.6115 12.5241H61.5426ZM70.1976 13.2273V20.5H68.8695L65.7054 15.9226H65.6522V20.5H64.1145V13.2273H65.464L68.6032 17.8011H68.6671V13.2273H70.1976ZM71.468 20.5V13.2273H73.0057V16.228H76.1271V13.2273H77.6612V20.5H76.1271V17.4957H73.0057V20.5H71.468ZM87.3265 13.2273V20.5H85.9984L82.8343 15.9226H82.7811V20.5H81.2434V13.2273H82.5929L85.7321 17.8011H85.796V13.2273H87.3265ZM89.8505 20.5H88.2028L90.7134 13.2273H92.695L95.2021 20.5H93.5543L91.7326 14.8892H91.6758L89.8505 20.5ZM89.7475 17.6413H93.6396V18.8416H89.7475V17.6413ZM92.4073 11.3239H93.462C93.4596 11.7547 93.2998 12.1016 92.9826 12.3643C92.6677 12.6271 92.2416 12.7585 91.7042 12.7585C91.1644 12.7585 90.7371 12.6271 90.4222 12.3643C90.1074 12.1016 89.9499 11.7547 89.9499 11.3239H90.9975C90.9951 11.4872 91.0472 11.634 91.1538 11.7642C91.2627 11.8944 91.4461 11.9595 91.7042 11.9595C91.9551 11.9595 92.1351 11.8956 92.244 11.7678C92.3529 11.6399 92.4073 11.492 92.4073 11.3239ZM102.161 13.2273V20.5H100.832L97.6683 15.9226H97.6151V20.5H96.0774V13.2273H97.4268L100.566 17.8011H100.63V13.2273H102.161ZM108.253 15.5781C108.204 15.4053 108.134 15.2526 108.044 15.12C107.954 14.9851 107.844 14.8714 107.714 14.7791C107.586 14.6844 107.439 14.6122 107.273 14.5625C107.11 14.5128 106.929 14.4879 106.73 14.4879C106.358 14.4879 106.032 14.5803 105.75 14.7649C105.47 14.9496 105.253 15.2183 105.096 15.571C104.94 15.9214 104.862 16.3499 104.862 16.8565C104.862 17.3632 104.939 17.794 105.093 18.1491C105.247 18.5043 105.465 18.7753 105.746 18.9624C106.028 19.147 106.361 19.2393 106.744 19.2393C107.092 19.2393 107.389 19.1778 107.635 19.0547C107.884 18.9292 108.073 18.7528 108.204 18.5256C108.336 18.2983 108.403 18.0296 108.403 17.7195L108.715 17.7656H106.84V16.608H109.883V17.5241C109.883 18.1634 109.748 18.7126 109.479 19.1719C109.209 19.6288 108.837 19.9815 108.363 20.2301C107.89 20.4763 107.348 20.5994 106.737 20.5994C106.055 20.5994 105.456 20.4491 104.94 20.1484C104.424 19.8454 104.022 19.4157 103.733 18.8594C103.446 18.3007 103.303 17.6378 103.303 16.8707C103.303 16.2812 103.388 15.7557 103.559 15.294C103.732 14.83 103.973 14.437 104.283 14.1151C104.593 13.7931 104.954 13.5481 105.366 13.38C105.778 13.2119 106.224 13.1278 106.705 13.1278C107.117 13.1278 107.501 13.1882 107.856 13.3089C108.211 13.4273 108.526 13.5954 108.8 13.8132C109.077 14.031 109.303 14.2902 109.479 14.5909C109.654 14.8892 109.766 15.2183 109.816 15.5781H108.253ZM115.931 20.5H114.038V19.1825H115.867C116.322 19.1825 116.704 19.102 117.014 18.9411C117.327 18.7777 117.561 18.5256 117.717 18.1847C117.876 17.8414 117.955 17.3987 117.955 16.8565C117.955 16.3191 117.876 15.88 117.717 15.5391C117.561 15.1982 117.328 14.9472 117.018 14.7862C116.707 14.6252 116.325 14.5447 115.871 14.5447H114.006V13.2273H115.952C116.684 13.2273 117.314 13.3729 117.841 13.6641C118.369 13.9529 118.775 14.3684 119.059 14.9105C119.346 15.4527 119.489 16.1013 119.489 16.8565C119.489 17.6141 119.346 18.2652 119.059 18.8097C118.775 19.3542 118.367 19.772 117.834 20.0632C117.304 20.3544 116.67 20.5 115.931 20.5ZM114.89 13.2273V20.5H113.353V13.2273H114.89ZM112.344 17.1122V16.2173H115.885V17.1122H112.344ZM122.166 13.2273V20.5H120.628V13.2273H122.166ZM125.745 20.5V13.2273H127.283V16.4339H127.379L129.996 13.2273H131.839L129.14 16.4837L131.871 20.5H130.032L128.039 17.5099L127.283 18.4332V20.5H125.745ZM132.64 20.5V13.2273H137.54V14.495H134.178V16.228H137.288V17.4957H134.178V19.2322H137.555V20.5H132.64ZM134.579 12.5241L133.496 10.9084H134.891L135.648 12.5241H134.579ZM138.763 13.2273H140.659L142.662 18.1136H142.747L144.75 13.2273H146.646V20.5H145.155V15.7663H145.095L143.213 20.4645H142.197L140.315 15.7486H140.254V20.5H138.763V13.2273Z"
          fill="white"
        />
      </g>
      <path
        d="M42.2513 16.3523C32.7513 8.18562 11.0025 -2.80013 3.0025 9.99987C-4.9975 22.7999 9.7471 15.4999 11.5 11.9999"
        stroke="black"
        strokeWidth="0.5"
      />
      <defs>
        <clipPath id="clip0_2175_156942">
          <rect
            width="141"
            height="32"
            fill="white"
            transform="translate(27 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconPlayVideo() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0003 18.8332C14.6027 18.8332 18.3337 15.1022 18.3337 10.4998C18.3337 5.89746 14.6027 2.1665 10.0003 2.1665C5.39795 2.1665 1.66699 5.89746 1.66699 10.4998C1.66699 15.1022 5.39795 18.8332 10.0003 18.8332Z"
        stroke="#0070F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91699 8.20201C7.91699 7.40332 8.80714 6.92693 9.47169 7.36996L12.9189 9.66811C13.5127 10.0639 13.5127 10.9364 12.9189 11.3322L9.47169 13.6304C8.80714 14.0734 7.91699 13.597 7.91699 12.7983V8.20201Z"
        stroke="#0070F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconActiveNext() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.458 10.2713H3.95801"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.417 5.25116L16.4587 10.2712L11.417 15.292"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconCircleDecorator() {
  return (
    <svg
      width="342"
      height="108"
      viewBox="0 0 342 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: "absolute", bottom: 0 }}
    >
      <g opacity="0.5" clipPath="url(#clip0_2175_156931)">
        <circle
          cx="133"
          cy="170"
          r="167.5"
          transform="rotate(90 133 170)"
          stroke="url(#paint0_linear_2175_156931)"
          strokeWidth="5"
        />
        <path
          d="M-7 167C-7 100.174 47.1736 46 114 46C180.826 46 235 100.174 235 167C235 233.826 180.826 288 114 288C47.1735 288 -7.00001 233.826 -7 167Z"
          stroke="url(#paint1_linear_2175_156931)"
          strokeWidth="4"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2175_156931"
          x1="81"
          y1="340"
          x2="-57.691"
          y2="134.006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#9EE4A1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2175_156931"
          x1="53.373"
          y1="77.9545"
          x2="213.236"
          y2="159.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6E7F7" />
          <stop offset="1" stopColor="#9EE4A1" />
        </linearGradient>
        <clipPath id="clip0_2175_156931">
          <rect
            width="110"
            height="440"
            fill="white"
            transform="translate(342) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconCircleDecorationSmall() {
  return (
    <svg
      width="180"
      height="67"
      viewBox="0 0 180 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2175_156934)">
        <path
          d="M90 65.0002C41.3935 65.0002 1.99999 25.7126 2 -22.7389C2 -71.1904 41.3935 -110.478 90 -110.478C138.607 -110.478 178 -71.1904 178 -22.7389C178 25.7126 138.607 65.0002 90 65.0002Z"
          stroke="url(#paint0_linear_2175_156934)"
          strokeWidth="4"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2175_156934"
          x1="24.8448"
          y1="21.4937"
          x2="83.941"
          y2="-95.2785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6E7F7" />
          <stop offset="1" stopColor="#9EE4A1" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2175_156934">
          <rect
            width="96"
            height="180"
            fill="white"
            transform="translate(180 -29) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
